module.exports = __webpack_public_path__ + "img/photo-24.7c67b535.jpg";